"use strict";

/**
 * @classdesc
 * Versteckt bzw. enttarnt einen Layer.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.layer.GCAbstractLayer} options.layer Anzuzeigender bzw. zu versteckender
 *   Layer
 */
gc.gis.action.layer.ToggleVisibility = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	/**
	 * @inheritdoc
	 */
	this.func = this.doToggle;
	/**
	 * @inheritdoc
	 */
	this.args = [options.layer];
};
gc.gis.action.layer.ToggleVisibility.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

/**
 * Versteckt bzw. enttarnt einen Layer.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer Anzuzeigender bzw. zu versteckender
 *   Layer
 */
gc.gis.action.layer.ToggleVisibility.prototype.doToggle = function( layer )
{
	layer.setVisible( !layer.isVisible() );
};

